import React, { useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import commonMessages from 'sg-common-messages';
import {
    Button, ModalBody, ModalFooter, ModalHeader, ModalNext
} from '@jutro/components';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import messages from './SgSptCancellationExcessConflictModal.messages';

function SgSptCancellationExcessConflictModal(props) {
    const {
        isOpen,
        onResolve,
        headerTitle,
        cancelBtnVisible,
        onCancelClick,
        onOKClick,
        modalMetadata,
        isCancellationPPOver15K,
        isCancellationEssentialOrStandard
    } = props;

    const [modalAnswer, setModalAnswer] = useState(undefined);
    const [showErrors, setShowErrors] = useState(false);

    const validationMessages = useMemo(() => {
        if (showErrors) {
            if (_.isNil(modalAnswer)) {
                return [messages.AnswerRequired.defaultMessage];
            }
            return [messages.CancellationPerPersonOver15000Blocked.defaultMessage];
        }
        return [];
    }, [modalAnswer, showErrors]);

    const writeValue = useCallback((newValue) => {
        if (newValue || isCancellationEssentialOrStandard) {
            setShowErrors(false);
        }
        setModalAnswer(newValue);
    }, [isCancellationEssentialOrStandard]);

    const handleCancelClick = () => {
        onCancelClick();
        onResolve();
    };
    const handleOKClick = () => {
        if (isCancellationPPOver15K) {
            if (modalAnswer) {
                setShowErrors(false);
                onOKClick(modalAnswer);
                onResolve();
            } else {
                setShowErrors(true);
            }
        } else if (isCancellationEssentialOrStandard) {
            if (!modalAnswer) {
                setShowErrors(true);
            }
            if (!_.isNil(modalAnswer)) {
                onOKClick(modalAnswer);
                onResolve();
            }
        } else {
            onOKClick();
            onResolve();
        }
    };

    const overrideProps = {
        SgSptCancellationExcessModalQuestion: {
            onValueChange: writeValue,
            value: modalAnswer,
            showErrors,
            validationMessages
        }
    };
    const resolvers = {
        resolveComponentMap: {}
    };

    return (
        <ModalNext isOpen={isOpen}>
            <div className="sgInfoModal">
                <ModalHeader
                    title={headerTitle}
                />
                <ModalBody
                    contentLayout={{
                        component: 'div',
                        componentProps: { className: 'sgInfoModalNotificationBodyAndQuestion' }
                    }}
                >
                    {renderContentFromMetadata(modalMetadata.componentContent, overrideProps, resolvers)}
                </ModalBody>
                <ModalFooter>
                    {cancelBtnVisible ? (
                        <Button
                            onClick={handleCancelClick}
                            type="outlined"
                        >
                            {commonMessages.ModalMessageCancel}
                        </Button>
                    ) : null}
                    <Button
                        onClick={handleOKClick}
                        type="filled"
                    >
                        {commonMessages.ModalMessageOK}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>
    );
}

SgSptCancellationExcessConflictModal.defaultProps = {
    cancelBtnVisible: true,
    headerTitle: messages.HeaderTitle.defaultMessage,
    isCancellationPPOver15K: false
};

SgSptCancellationExcessConflictModal.propTypes = {
    headerTitle: PropTypes.string,
    cancelBtnVisible: PropTypes.bool,
    isCancellationPPOver15K: PropTypes.bool
};

export default SgSptCancellationExcessConflictModal;
